export class FilterModel {

  public static readonly checkbox = ['spec', 'loc', 'visa', 'cc'];
  public static readonly range = ['tp', 'tfyp', 'usmd', 'img', 'do', 'fys', 'hrs'];

  public spec: string[] = [];
  public loc: string[] = [];
  public visa: string[] = [];
  public cc: string[] = [];
  public at: string[] = [];
  public pt: string[] = [];
  public st: string[] = [];
  public tp: string[] = [];
  public tfyp: string[] = [];
  public usmd: string[] = [];
  public img: string[] = [];
  public do: string[] = [];
  public fys: string[] = [];
  public hrs: string[] = [];

  constructor(values?: Partial<FilterModel>) {
    Object.assign(this, values);
  }
}
